import React from "react";
import { Box, Modal, Grid, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { getEquipmentIcon } from "../../utils/equipmentIcons";

interface EquipmentsModalProps {
  open: boolean;
  onClose: () => void;
  amenities: any;
}

const EquipmentsModal: React.FC<EquipmentsModalProps> = ({
  open,
  onClose,
  amenities,
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: "absolute" as "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "100%",
          maxWidth: 800,
          bgcolor: "background.paper",
          border: "1px solid #000",
          boxShadow: 24,
          borderRadius: "10px",
        }}
      >
        <Box
          display="flex"
          justifyContent="center"
          width="100%"
          position="relative"
          borderBottom="1px solid #d3d3d3"
          py={1}
        >
          <Typography
            variant="h6"
            sx={{ fontWeight: "bold", fontSize: "18px" }}
          >
            Equipment
          </Typography>
          <Box
            justifyContent="flex-end"
            alignItems="flex-start"
            sx={{
              position: "absolute",
              top: 0,
              right: 0,
            }}
          >
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Box>
        </Box>
        <Grid
          container
          spacing={2}
          sx={{ maxHeight: 400, overflowY: "auto", pb: 2, m: 0, width: "100%" }}
        >
          {amenities.filter((a: any) => a.name?.trim() && a.name.trim().toLowerCase() !== "unknown").map((amenity: any, index: number) => (
            <Grid item xs={12} sm={6} md={4} key={index}
              sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Box sx={{ color: "text.secondary", display: "flex", alignItems: "center", flexShrink: 0 }}>
                {getEquipmentIcon(amenity.name) ?? <CheckCircleOutlineIcon fontSize="small" />}
              </Box>
              <Typography variant="body2">
                {amenity.name}
              </Typography>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Modal>
  );
};

export default EquipmentsModal;
